import { render } from "./MoreIcon.vue?vue&type=template&id=71b7e812&scoped=true"
import script from "./MoreIcon.vue?vue&type=script&lang=js"
export * from "./MoreIcon.vue?vue&type=script&lang=js"

import "./MoreIcon.vue?vue&type=style&index=0&id=71b7e812&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b7e812"]])

export default __exports__